<template>
  <div v-loading="MD5Loading" element-loading-text="正在校验MD5请稍等...">
    <div class="upload">
      <el-steps :space="200" :active="stepActive" finish-status="success" class="steps">
        <el-step class="style" title="选择类型"></el-step>
        <el-step class="style" title="上传资料"></el-step>
        <el-step class="end"></el-step>
      </el-steps>
      <el-form
        v-if="steps == 1"
        :rules="rules"
        ref="form"
        :model="form"
        label-width="100px"
        class="form1"
        label-position="right"
      >
        <el-form-item label="原创类型：" prop="produceType">
          <el-select v-model="form.produceType" clearable placeholder="请选择原创类型">
            <el-option
              :label="item.name"
              :value="item.index"
              v-for="item in produceTypeOptions"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="item.title + '：'"
          v-for="item in selectList"
          :key="item.id"
        >
          <el-select
            v-model="formType['big' + item.id]"
            clearable
            :placeholder="'请选择' + item.title"
            filterable
          >
            <el-option
              v-for="(chItem, index) in item.children"
              :key="index"
              :label="chItem.title"
              :value="chItem.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中英双语类：">
          <el-checkbox @change="changebilg" v-model="bilingual"></el-checkbox>
        </el-form-item>
        <el-form-item label="文件标签：" prop="label">
          <el-tag
            style="margin-right: 10px; margin-left: 0"
            :key="tag"
            v-for="tag in form.label"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            maxlength="10"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput"
            >+ 添加标签</el-button
          >
          <div class="notes">
            <i>注：</i>

            <span>1.建议标签长度4个字</span>
            <br />
            <span>2.默认批量上传的文件使用相同标签</span>
          </div>
        </el-form-item>
        <div class="btn_box">
          <el-form-item>
            <el-button type="primary" @click="onSubmit">下一步</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div v-if="steps == 2" class="start_upload">
      <div class="shiy_center">
        <el-radio-group v-model="uploadtab">
          <el-radio-button label="1">上传文件</el-radio-button>
          <el-radio-button label="2">填写链接</el-radio-button>
        </el-radio-group>
      </div>
      <p class="label" v-if="uploadtab == '1'">
        上传文件
        <span class="tishi_txt"
          >(1.请上传.zip格式文件 2.压缩包名请使用原文件夹名
          3.文件夹内要有index.html)  </span>
       <el-tooltip class="item" effect="light" placement="top-start">
          <div slot="content">
            pdf、txt、doc、xls、xlsx、docx、ppt、pptx、<br />mp4、png、jpg、jpeg、ico、gif、flic、fli、<br />flc、swf、avi、mp3、wav、js、html、css、<br />unityweb、json
          </div>
          <p class="type_filetxt">注 ： 文件类型限制 <span>(鼠标悬停查看)</span> </p>
        </el-tooltip>
      </p>
      <div class="upload_box" v-if="uploadtab == '1'">
        <uploader
          ref="uploader"
          :options="options"
          :autoStart="false"
          @file-added="onFileAdded"
          class="uploader-app"
        >
          <uploader-unsupport></uploader-unsupport>
          <uploader-btn id="global-uploader-btn" :attrs="attrs" ref="uploadBtn">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </uploader-btn>
        </uploader>
      </div>
      <div class="upload_href" v-if="uploadtab == '2'">
        <div style="margin-top: 15px">
          <el-input
            placeholder="请输入资源链接地址"
            v-model="hrefinp"
            class="input-with-select"
          >
            <el-button slot="append" @click="hrefbtns">确定</el-button>
          </el-input>
        </div>
      </div>
      <!-- 上传 -->
    </div>
    <div class="upload_list" v-if="steps == 3">
      <ul class="upload_item" v-for="(file, index) in fileList" :key="file.id">
        <span class="deleted el-icon-delete" @click="handleDeleteItemFile(index)"></span>
        <li>
          <span class="label">* 文件名称：</span>
          <el-input
            :maxlength="50"
            v-model="file.basicForm.fileName"
            placeholder="请输入文件名称"
            style="width: 260px"
          ></el-input>
        </li>
        <!-- 筛选条件的类型 -->
        <div class="type_allsd">
          <el-collapse v-model="file.active" accordion>
            <el-collapse-item title="专业大类、专业类..." name="1">
              <el-form label-width="100px" class="form1" label-position="right">
                <el-form-item
                  :label="item.title + '：'"
                  v-for="item in file.basicForm.selectList"
                  :key="item.id"
                >
                  <el-select
                    v-model="file.basicForm.bigtype['big' + item.id]"
                    clearable
                    :placeholder="'请选择' + item.title"
                    filterable
                  >
                    <el-option
                      v-for="(chItem, index) in item.children"
                      :key="index"
                      :label="chItem.title"
                      :value="chItem.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 虚拟仿真的富文本材料 -->
        <div class="xn_txt">
          <el-tabs tab-position="top" v-model="file.activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in file.basicForm.tabuplist"
              :key="index"
              :label="item.name"
              :name="item.name"
            >
              <Toolbar
                style="border-bottom: 1px solid #ccc; height: 150px"
                :editor="item.editor"
                :defaultConfig="toolbarConfig"
                mode="default"
              />
              <Editor
                style="height: 500px; overflow-y: hidden"
                v-model="item.content"
                :defaultConfig="editorConfig"
                mode="default"
                @onCreated="onCreated"
                @onChange="onChange"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
        <li>
          <span class="label">实验简介：</span>

          <div class="upload_box" @click="onupclick(index, 1)">
            <uploader
              ref="uploadertwo"
              :options="options"
              :autoStart="false"
              @file-added="onFileAddedtwo"
              class="uploader-app"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-btn id="global-uploader-btn" :attrs="attrstwo" ref="uploadBtntwo">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </uploader-btn>
            </uploader>
          </div>
          <div class="vid_active" v-if="file.introductionUrl">
            <video
              :src="formatUrl(file.introductionUrl)"
              controls
              controlsList="nodownload"
            ></video>
          </div>
        </li>
        <li class="teach_url">
          <span class="label">教学引导：</span>
          <div class="upload_box" @click="onupclick(index, 2)">
            <uploader
              ref="uploadertwo"
              :options="options"
              :autoStart="false"
              @file-added="onFileAddedtwo"
              class="uploader-app"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-btn id="global-uploader-btn" :attrs="attrstwo" ref="uploadBtntwo">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </uploader-btn>
            </uploader>
          </div>
          <div class="vid_active" v-if="file.teachingUrl">
            <video
              :src="formatUrl(file.teachingUrl)"
              controls
              controlsList="nodownload"
            ></video>
          </div>
        </li>
        <li>
          <span class="label">标签：</span>
          <div style="flex: 1">
            <el-tag
              style="margin-right: 10px; margin-left: 0; margin-bottom: 3px"
              :key="tag"
              v-for="tag in file.basicForm.label"
              closable
              :disable-transitions="false"
              @close="handleEditClose(file, tag, index)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              style="margin-bottom: 3px"
              class="input-new-tag"
              v-if="file.params.labelVisible"
              v-model="inputValue"
              maxlength="10"
              :ref="'saveTagInput' + index"
              size="small"
              @keyup.enter.native="handleEditInputConfirm(file, index)"
              @blur="handleEditInputConfirm(file, index)"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showEditInput(file, index)"
              icon="el-icon-edit"
              style="font-size: 15px; color: #2e5cce"
            ></el-button>
          </div>
        </li>
        <li>
          <span class="label">封面：</span>
          <el-upload
            class="avatar-uploader"
            accept=".jpeg,.png,.jpg"
            :action="imgUrl"
            :headers="header"
            :show-file-list="false"
            :data="{ uploadId: file.params.uploadId }"
            :on-success="(res, file) => handleAvatarSuccessFen(res, file, index)"
            :before-upload="beforeAvatarUploadFen"
            v-if="hrefinp == null"
          >
            <img
              v-if="file.params.isFileUploadFlag"
              :src="$http.requrl + '/profile/' + file.params.customizeCoverUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
            <el-upload
            class="avatar-uploader"
            accept=".jpeg,.png,.jpg"
            :action="imgUrltwo"
            :headers="header"
            :show-file-list="false"
            :on-success="(res, file) => handleAvatar(res, file, index)"
            :before-upload="beforeAvatarUploadFen"
            v-else
          >
            <img
              v-if="file.params.isFileUploadFlag"
              :src="$http.requrl + '/profile/' + file.params.customizeCoverUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </li>
        <li>
          <span class="label" style="width: 100px">*资源简介：</span>
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="file.basicForm.textarea"
          >
          </el-input>
        </li>
        <li>
          <el-checkbox v-show="false" v-model="file.basicForm.checked"
            >取消勾选该资源不可下载</el-checkbox
          >
        </li>
        <p
          class="line"
          v-if="file.params.isprogress"
          :style="{ width: file.params.progress }"
        ></p>
        <p class="line errLine" v-else :style="{ width: file.params.progress }"></p>
      </ul>
      <div class="btn_box">
        <el-button type="primary" :loading="isAddZiYuan" @click="handleAddResources"
          >添加资源</el-button
        >
        <!-- <el-button type="primary">继续添加</el-button> -->
      </div>
    </div>
    <div class="upload_list" v-if="steps == 4">
      <el-empty description="上传完毕，即将返回"></el-empty>
    </div>
  </div>
</template>
<script>
import SparkMD5 from "spark-md5";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {DomEditor} from "@wangeditor/editor";
const ACCEPT_CONFIG = {
  image: [".png", ".jpg", ".jpeg", ".gif", ".bmp"],
  video: [".mp4", ".rmvb", ".mkv", ".wmv", ".flv"],
  document: [
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".pdf",
    ".txt",
    ".tif",
    ".tiff",
  ],
  getAll() {
    return [...this.image, ...this.video];
  },
};
export default {
  name: "Upload",
  data() {
    // 自定义验证 标签不能为空
    const checkLabel = (rule, value, callback) => {
      if (value.length > 0) {
        callback();
      } else {
        callback(new Error("标签不能为空"));
      }
    };
    return {
      stepActive: 0,
      steps: 1,
      form: {
        mediaType: "",
        produceType: "",
        label: [],
        fileName: "",
        fileImg: "",
        textarea: "",
        checked: false,
        isShow: false,
        bilingual: 0,
      },
      bilingual: 0,
      // 小类
      formType: {},
      mediaTypeOptions: [],
      produceTypeOptions: [],
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      options: {
        target: "http://www.baidu.com",
        chunkSize: "2048000",
        fileParameterName: "upfile",
        maxChunkRetries: 3,
        testChunks: true, //是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message);
          if (objMessage.skipUpload) {
            return true;
          }
          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        },
        query: (file, chunk) => {
          return {
            ...file.params,
          };
        },
      },
      attrs: {
        //accept: [...ACCEPT_CONFIG.getAll()],
        accept: [".zip"],
      },
      attrstwo: {
        accept: [".mp4"],
      },
      params: {},
      selectList: [],
      fileList: [],
      imgUrl: "",
      imgUrltwo: "",
      header: {
        Authorization: "",
      },
      rules: {
        label: [{ required: true, validator: checkLabel, trigger: "blue" }],
      },
      isAddZiYuan: true,
      userVisible: false,
      // 部门树选项
      deptList: [],
      // 重新渲染表格状态
      refreshTable: true,
      // 遮罩层
      loading: true,
      // 是否展开，默认全部展开
      isExpandAll: true,
      //此部门用户列表
      deptUserList: [],
      chooseDeptUserList: [],
      //无部门用户列表
      noDeptUserList: [],
      chooseNoDeptUserList: [],
      //已选用户列表
      chooseUserList: [],
      chooseIds: [],
      chooseUserIds: [],
      // md5页面计算loading
      MD5Loading: false,
      // 判断是否计算完毕的依据
      MD5Num: 0,
      // ---多文件上传
      selId: null, //媒体类型选择ID
      upselId: null, //文件上传后的类型选择三级联动
      editorlist: [],
      fileinex: null, //点击上传两个视频时记录位置
      baseurl: this.$http.requrl,
      ednum: -1, //富文本渲染的下标
      edlistnum: 0, //文件列表下标
      loadingupload: null, //文件检验Loading
      toolbarConfig: {
        excludeKeys: ["uploadVideo", "emotion"],
      }, //去除富文本某些菜单
      editorConfig:{
        placeholder: '请输入内容...',
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            customUpload: this.uploadImageMe // this.uploadImageMe 是 methods 中的一个普通方法
          },
        }
      },
      uploadtab: "1", //上传文件或链接选择
      hrefinp: null, //输入链接地址
    };
  },
  components: { Editor, Toolbar },
  computed: {
    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
  },
  created() {
    this.imgUrl = process.env.VUE_APP_BASE_API + "/business/upload/uploadCover";
    this.imgUrltwo = process.env.VUE_APP_BASE_API + "/common/upload";
    this.header["Authorization"] = localStorage.getItem("tooken");
    this.getWebList();
    this.getMediaTypes();
    this.getProduceTypes();
  },
  mounted() {
    //上传时的资料菜单列表
    this.editlist();
  },
  methods: {
    formatUrl(url) {
      return url == null
        ? url
        : url.startsWith("/profile")
        ? this.baseurl + url
        : this.baseurl + "/profile/" + url;
    },
    // 获取小类列表
    getWebList() {
      this.$http.get("/business/big/webList").then((res) => {
        if (res.code == 200) {
          res.rows.forEach((v) => {
            this.$set(this.formType, "big" + v.id, "");
          });
          this.selectList = res.rows;
        }
      });
    },
    // 获取文件类型列表
    getMediaTypes() {
      this.$http.get("/business/big/getTypes").then((res) => {
        if (res.code == 200) {
          this.mediaTypeOptions = res.data;
        }
      });
    },
    // 获取原创类型列表
    getProduceTypes() {
      this.$http.get("/business/big/getProduceTypes").then((res) => {
        if (res.code == 200) {
          this.produceTypeOptions = res.data;
        }
      });
    },
    // 添加标签开始
    handleClose(tag) {
      this.form.label.splice(this.form.label.indexOf(tag), 1);
    },
    showInput() {
      // if (this.form.label.length >= 4) {
      //   this.$message.info('不能超过四个标签')
      //   return
      // }
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        if (this.form.label.indexOf(inputValue) > -1) {
          this.$message.info("标签不能重复");
        } else {
          this.form.label.push(inputValue);
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    // 添加标签结束

    // 修改标签开始
    handleEditClose(file, tag) {
      file.basicForm.label.splice(file.basicForm.label.indexOf(tag), 1);
    },
    showEditInput(file, index) {
      // if (file.basicForm.label.length >= 4) {
      //   this.$message.info("不能超过四个标签");
      //   return;
      // }
      this.fileList[index].params.labelVisible = true;
      this.$nextTick((_) => {
        this.$refs["saveTagInput" + index][0].$refs.input.focus();
      });
    },
    handleEditInputConfirm(file, index) {
      let inputValue = this.inputValue;
      if (inputValue) {
        if (file.basicForm.label.indexOf(inputValue) > -1) {
          this.$message.info("标签不能重复");
        } else {
          file.basicForm.label.push(inputValue);
        }
      }
      file.params.labelVisible = false;
      this.inputValue = "";
    },
    // 修改标签结束

    // 限制上传的文件类型
    handlemediaChange(id) {
      this.mediaTypeOptions.forEach((v) => {
        if (v.index === id) {
          this.selId = id;
          this.attrs.accept = v.suffix.map((v) => {
            return "." + v;
          });
        }
      });
    },
    // 信息填写完毕下一步
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.stepActive = 1;
          this.steps = 2;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleEditLabel(file) {
      file.basicForm.isShow = !file.basicForm.isShow;
    },
    // 添加上传的文件
    onFileAdded(file, fileList) {
      this.computeMD5(file);
      this.MD5Num++;
      this.MD5Loading = true;
      this.hrefinp = null;
      // 2022/1/10 将额外的参数赋值到每个文件上，解决了不同文件使用不同params的需求
      file.params = this.params;
      file.params.isFileUploadFlag = false;
      file.params.isDataUploadFlag = false;
      file.params.labelVisible = false;
      file.params.progress = "0%";
      file.params.isprogress = true;
      file.basicForm = { ...this.form };
      file.basicForm.fileName = file.name
        .split(".")
        .splice(0, file.name.split(".").length - 1)
        .join(".");
      file.basicForm.types = [];
      for (var key in this.formType) {
        if (this.formType[key]) {
          file.basicForm.types.push(this.formType[key]);
        }
      }
    },
    // 生成文件的md5值
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // 文件状态设为"计算MD5"
      // this.statusSet(file.id, 'md5');
      file.pause();
      loadNext();
      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            $(`.myStatus_${file.id}`).text(
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
            );
          });
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
          this.MD5Num--;
          if (this.MD5Num == 0) {
            this.MD5Loading = false;
          }
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    // 上传文件的md5值
    computeMD5Success(md5, file) {
      this.loadingupload = this.$loading({
        text: "文件检验中......",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      file.uniqueIdentifier = md5;
      let fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);

      this.$http
        .post("/business/upload/getUploadId", null, {
          params: {
            filemd5: md5,
            suffix: fileExtension,
            size: file.size,
            oldName: file.name.split(".")[0],
          },
        })
        .then((res) => {
          if (res.code < 300) {
            const data = res.data;

            let defaultImg = `default/${fileExtension}.png`;
            if (
              fileExtension == "png" ||
              fileExtension == "jpg" ||
              fileExtension == "jpeg"
            ) {
              defaultImg = `${res.data.url}`;
            }
            file.params = {
              filemd5: md5,
              suffix: fileExtension,
              ...file.params,
              ...data,
              customizeCoverUrl: defaultImg,
            };

            file.basicForm["bigtype"] = {};
            file.basicForm["tabuplist"] = this.tabuplist;
            file.basicForm["selectList"] = this.selectList;
            file["activeName"] = this.tabuplist[0].name;
            //实验简介视频
            file["introductionUrl"] = null;
            //实验教学视频
            file["teachingUrl"] = null;
            //类型选择的折叠mode
            file.active = ["0"];
            //如何上传前类型已选---回显
            file.basicForm.bigtype = this.formType;
            //上传压缩包返回的链接
            file["htmlUrl"] = data.htmlUrl;
            this.fileList.push(JSON.parse(JSON.stringify(file)));

            this.PostFile(
              file,
              0,
              data.custSize,
              data.indexCount,
              data.uploadId,
              this.fileList.length - 1
            );
          } else {
            // this.$message.warning('登录过期，请重新登录')
          }
        })
        .catch((err) => {});
      // file.resume();
    },
    // 文件切片
    PostFile(file, i, shardSize, indexCount, uploadId, lisPos) {
      // debugger
      var name = file.name, //文件名
        size = file.size, //总大小shardSize = 2 * 1024 * 1024,
        //shardSize = 10 * 1024 * 1024,                //以2MB为一个分片,每个分片的大小
        shardCount = Math.ceil(size / shardSize); //总片数
      if (i >= shardCount) {
        return;
      }
      console.log(size, i + 1, shardCount); //文件总大小，第一次，分片大小//
      var start = i * shardSize;
      var end = start + shardSize;
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      var packet = blobSlice.call(file.file, start, end); //将文件进行切片
      var form = new FormData();
      form.append("file", packet); //slice方法用于切出文件的一部分
      form.append("index", i + 1);
      form.append("uploadId", uploadId);
      this.$http.post("/business/upload/uploadIndex", form).then((res) => {
        if (res.code < 300) {
          if (!res.data) {
            this.fileList[lisPos].params.progress = (i / shardCount) * 100 + "%";
            form = "";
            i++;
            this.PostFile(file, i, shardSize, indexCount, uploadId, lisPos);
          } else {
            this.fileList[lisPos].params.progress = "100%";
            this.fileList[lisPos].params.isFileUploadFlag = true;
            let abc = this.fileList.filter((v) => v.params.isFileUploadFlag === false);
            if (abc.length == 0) {
              this.isAddZiYuan = false;
              this.stepActive = 2;
              this.steps = 3;
              this.$message.success("文件上传完成");
              this.loadingupload.close();
            }
          }
        } else {
          this.fileList[lisPos].params.isFileUploadFlag = true;
          this.fileList[lisPos].params.isprogress = false;
          this.loadingupload.close();

          this.$alert(res.msg, "警告", {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {
              this.steps = 1;
              this.stepActive = 0;
              this.fileList = [];
              this.$router.push({
                path: "/redirect" + this.$route.fullPath,
              });
            },
          });
        }
      });
    },
    handleDeleteItemFile(index) {
      this.fileList.splice(index, 1);
      if (this.fileList.length === 0) {
        this.steps = 1;
        this.stepActive = 0;
        this.fileList = [];
        this.$router.push({
          path: "/redirect" + this.$route.fullPath,
        });
      }
    },
    // 上传文件
    handleAddResources() {
      for (let index = 0; index < this.fileList.length; index++) {
        const element = this.fileList[index];
        if (!element.basicForm.fileName) {
          this.$notify({
            title: "警告",
            message: `文件名不能为空`,
            type: "warning",
          });
          return false;
        }
        if (!element.basicForm.label.length) {
          this.$notify({
            title: "警告",
            message: `标签不能为空`,
            type: "warning",
          });
          return false;
        }
        if (!element.basicForm.textarea) {
          this.$notify({
            title: "警告",
            message: `资源简介不能为空`,
            type: "warning",
          });
          return false;
        }
        // - 将已选中的types筛选出来 -
        element.basicForm.types = [];
        for (var key in element.basicForm.bigtype) {
          if (element.basicForm.bigtype[key]) {
            element.basicForm.types.push(element.basicForm.bigtype[key]);
          }
        }
      }
      this.isAddZiYuan = true;
      this.fileList.forEach((v) => {
        if (!v.params.isDataUploadFlag) {
          this.$http
            .post("/business/upload/add", {
              uploadId: v.params.uploadId,
              title: v.basicForm.fileName,
              originalName: v.name,
              suffix: v.params.suffix,
              fileSize: v.size,
              tags: v.basicForm.label,
              resourceUrl: v.params.url,
              coverUrl: v.params.customizeCoverUrl,
              description: v.basicForm.textarea,
              allowDownload: v.basicForm.checked,
              types: v.basicForm.types,
              zykMaterialMenus: v.basicForm.tabuplist,
              produceType: v.basicForm.produceType,
              currentName: v.params.filemd5 + "." + v.params.suffix,
              viewUserIds: this.chooseUserIds,
              //两个单独的视频
              introductionUrl: v.introductionUrl,
              teachingUrl: v.teachingUrl,
              //文件链接
              htmlUrl: v.htmlUrl,
              //中英双语分类
              bilingual: this.form.bilingual,
            })
            .then((res) => {
              v.params.isDataUploadFlag = true;
              let abc = this.fileList.filter((v) => v.params.isDataUploadFlag === false);
              if (abc.length == 0) {
                this.steps = 4;
                this.stepActive = 3;
                if (res.code == 200) {
                  this.$message.success("上传成功");
                }
                setTimeout(() => {
                  this.steps = 1;
                  (this.stepActive = 0),
                    (this.form = {
                      mediaType: "",
                      label: [],
                      fileName: "",
                      fileImg: "",
                      textarea: "",
                      checked: false,
                      isShow: false,
                    });
                  for (var keys in this.formType) {
                    this.formType[keys] = "";
                  }
                  this.fileList = [];
                }, 5000);
                //为了个人信息里的统计数据及时更新
                this.userdata();
                this.isAddZiYuan = false;
              }
            })
            .catch((err) => {
              this.isAddZiYuan = false;
            });
        }
      });
    },
    // 上传文件封面
    beforeAvatarUploadFen(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传封面图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    // 封面上传成功
    handleAvatarSuccessFen(res, file, index) {
      this.fileList[index].params.customizeCoverUrl = res.msg;
    },
     handleAvatar(res, file, index) {
      this.fileList[index].params.customizeCoverUrl = res.fileName.replace('/profile/',' ');
    },
    // 查询用户信息统计
    userdata() {
      this.$http.get("/system/user/myDetail").then((res) => {
        if (res.code == 200) {
          let usdata = JSON.stringify(res.data);
          localStorage.setItem("userdata", usdata);
          if (localStorage.getItem("userdata")) {
            this.$store.commit("userdata", JSON.parse(localStorage.getItem("userdata")));
          }
        }
      });
    },
    //清除媒体类型
    cleartype() {
      this.getMediaTypes();
    },
    // 文件上传后的分类选择
    fmtypeseltwo(chId) {
      var selbigval = [];
      var selchIdval = [];
      var basicForm = this.fileList[this.upselId.index].basicForm;
      if (this.upselId.bigid == 3 || this.upselId.bigid == 4) {
        selbigval = basicForm.selectList.filter((el) => {
          return el.id === this.upselId.bigid;
        });
        selchIdval = selbigval[0].children.filter((el) => {
          return el.id === chId;
        });
      }

      switch (this.upselId.bigid) {
        case 3:
          this.threeseltwo(4, selchIdval[0].remark);
          basicForm.bigtype.big4 = "";
          basicForm.bigtype.big28 = "";
          break;
        case 4:
          this.threeseltwo(28, selchIdval[0].remark);
          basicForm.bigtype.big28 = "";
          break;
        default:
          break;
      }
    },
    focusfmtytwo(bigid, index) {
      //index---文件列表的数组下标 bigid---小类ID
      this.upselId = { bigid: bigid, index: index };
    },
    //三级联动查询---文件上传后
    threeseltwo(typeBigId, remark) {
      var basicForm = this.fileList[this.upselId.index].basicForm;
      if (remark == "" || remark == "null" || remark == undefined || remark == null) {
        for (let index = 0; index < basicForm.selectList.length; index++) {
          if (typeBigId == basicForm.selectList[index].id) {
            basicForm.selectList[index].children = [];
          }
        }
        return;
      }
      let data = {
        typeBigId: typeBigId,
        remark: remark,
      };

      this.$http.post("/business/small/getUploadTypeList", data).then((res) => {
        if (res.code == 200) {
          for (let index = 0; index < basicForm.selectList.length; index++) {
            if (typeBigId == basicForm.selectList[index].id) {
              basicForm.selectList[index].children = res.data;
            }
          }
        }
      });
    },
    // 上传的tabs列表
    handleClick(tab) {
      // console.log(tab.name);
    },
    // 富文本
    onCreated(editor) {
      this.ednum++;
      if (this.ednum > 8) {
        this.ednum = 0;
        this.edlistnum++;
      }
      this.editorlist.push(editor);
      const edhtlist = this.fileList[this.edlistnum].basicForm.tabuplist;

      edhtlist[this.ednum].editor = Object.seal(editor);
    },
    onChange(editor) {
      const toolbar = DomEditor.getToolbar(editor);
      // console.log("工具栏配置", toolbar.getConfig().toolbarKeys); // 工具栏配置
    },
    //上传时的菜单列表
    editlist() {
      this.$http.get("/business/menu/list").then((res) => {
        if (res.code == 200) {
          this.tabuplist = res.rows;
          var editlist = {
            editor: null,
            content: "",
          };
          //添加富文本属性参数
          for (let index = 0; index < this.tabuplist.length; index++) {
            this.tabuplist[index] = { ...this.tabuplist[index], ...editlist };
            this.tabuplist[index]["menuId"] = this.tabuplist[index].id;
          }
        }
      });
    },
    // 点击视频上传框
    onupclick(index, keyp) {
      //keyp---代表是哪个视频  1-简介视频 2-教学视频
      this.fileweizhi = { fileindex: index, keyp: keyp };
    },
    // 实验简介视频上传
    onFileAddedtwo(file) {
      this.computeMD5two(file);
      this.MD5Num++;
      this.MD5Loading = true;
    },
    // 生成文件的md5值
    computeMD5two(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // 文件状态设为"计算MD5"
      // this.statusSet(file.id, 'md5');
      file.pause();
      loadNext();
      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            $(`.myStatus_${file.id}`).text(
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
            );
          });
        } else {
          let md5 = spark.end();
          this.computeMD5Successtwo(md5, file);
          this.MD5Num--;
          if (this.MD5Num == 0) {
            this.MD5Loading = false;
          }
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    // 上传文件的md5值
    computeMD5Successtwo(md5, file) {
      file.uniqueIdentifier = md5;
      let fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);
      this.$http
        .post("/business/upload/getUploadId", null, {
          params: {
            filemd5: md5,
            suffix: fileExtension,
            size: file.size,
          },
        })
        .then((res) => {
          if (res.code < 300) {
            const data = res.data;
            this.PostFiletwo(
              file,
              0,
              data.custSize,
              data.indexCount,
              data.uploadId,
              this.fileList.length - 1,
              data.url
            );
          } else {
          }
        });
    },
    // 文件切片
    PostFiletwo(file, i, shardSize, indexCount, uploadId, lisPos, url) {
      const loadingupload = this.$loading({
        text: "视频努力上传中......",
        spinner: "el-icon-loading",
        background: "rgba(256, 256, 256, 0.7)",
      });
      // debugger
      var name = file.name, //文件名
        size = file.size, //总大小shardSize = 2 * 1024 * 1024,
        //shardSize = 10 * 1024 * 1024,                //以2MB为一个分片,每个分片的大小
        shardCount = Math.ceil(size / shardSize); //总片数
      if (i >= shardCount) {
        return;
      }
      console.log(size, i + 1, shardSize, shardCount); //文件总大小，第一次，分片大小//
      var start = i * shardSize;
      var end = start + shardSize;
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      var packet = blobSlice.call(file.file, start, end); //将文件进行切片
      var form = new FormData();
      form.append("file", packet); //slice方法用于切出文件的一部分
      form.append("index", i + 1);
      form.append("uploadId", uploadId);
      this.$http
        .post("/business/upload/uploadIndex", form)
        .then((res) => {
          if (res.code < 300) {
            if (!res.data) {
              i++;
              this.PostFiletwo(file, i, shardSize, indexCount, uploadId, url);
            } else {
              switch (this.fileweizhi.keyp) {
                case 1:
                  this.fileList[this.fileweizhi.fileindex].introductionUrl = url;

                  break;
                case 2:
                  this.fileList[this.fileweizhi.fileindex].teachingUrl = url;
                  break;
                default:
                  break;
              }
              loadingupload.close();
              this.$message.success("文件上传完成");
            }
          } else {
            loadingupload.close();
          }
        })
        .catch((err) => {
          loadingupload.close();
        });
    },
    // 中英双语类
    changebilg(val) {
      this.bilingual = val;
      if (val == true) {
        this.form.bilingual = 1;
      } else {
        this.form.bilingual = 0;
      }
    },
    //上传文件配置
    uploadImageMe(file, insertFn){
      // file 即选中的文件
      // 自己实现上传，并得到图片 url alt href
      let name = file.name;
      let suffix = file.type.split("/")[1];
      name = name + '.' + suffix;

      let formdata = new FormData()
      formdata.append("file", file)

      this.$http.post("/common/upload", formdata).then((res) => {
        // 最后插入图片
        insertFn(res.url , res.fileName, res.url )
      });
    },
    //提交链接
    hrefbtns() {

      this.fileList = [{
        basicForm:{
          fileName:"",
          selectList:this.selectList,
          tabuplist:this.tabuplist,
          bigtype:this.formType,
          label:this.form.label,
          textarea:"",
          types:[],
          produceType:this.form.produceType,
          checked:false,
        },
        params:{
          isFileUploadFlag:true,
          isDataUploadFlag:false,
          labelVisible:false,
          progress:"100%",
          isprogress:true,
          customizeCoverUrl:`default/zip.png`,
          suffix:'zip',
          uploadId:1,
          url:this.hrefinp,
          filemd5:1,
        },
        active:["0"],
        activeName:this.tabuplist[0].name,
        introductionUrl:null,
        teachingUrl:null,
        htmlUrl:this.hrefinp,
        bilingual:this.form.bilingual,
        viewUserIds:this.chooseUserIds,
        size:1,
        name:1,
      }];
       this.isAddZiYuan = false;
       this.stepActive = 2;
       this.steps = 3;
    },
  },
  beforeDestroy() {
    for (let index = 0; index < this.fileList.length; index++) {
      const edhtlist = this.fileList[index].basicForm.tabuplist;
      for (let key = 0; key < edhtlist.length; key++) {
        const editor = edhtlist[key].editor;
        if (editor == null) return;
        editor.destroy(); // 组件销毁时，及时销毁编辑器
      }
    }
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.upload {
  width: 640px;
  margin: 0 auto;
  padding-top: 23px;
  margin-top: 23px;

  .steps {
    margin: 0 0 56px 25px;
  }

  .style {
    flex-basis: 300px !important;
    position: relative;
  }

  .end {
    flex-basis: 32px !important;
  }

  ::v-deep {
    .el-step__main {
      text-align: center;
      width: 100%;
      position: absolute;
      top: -30px;
      left: 0;
    }

    .el-step__title.is-success {
      color: #417bda;
    }

    .el-step__head.is-success {
      color: #417bda;
      border-color: #417bda;
    }
  }

  .form1 {
    ::v-deep .el-select {
      width: 100%;
    }

    .btn_box {
      text-align: right;

      ::v-deep .el-button--primary {
        width: 220px;
        height: 36px;
        line-height: 36px;
        background: #50ddbb;
        padding: 0;
        border: none;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .notes {
    color: #999999;
    position: relative;
    padding-left: 30px;
    line-height: 1.5;
    margin-top: 20px;

    i {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
.start_upload {
  width: 640px;
  margin: 0 auto;
  position: relative;

  // radio选择
  .shiy_center {
    text-align: center;
  }
  .label {
    font-size: 14px;
    padding: 10px 15px;
    .tishi_txt {
      color: orange;
    }
    .type_filetxt{
      width: 230px;
      margin: 10px 0;
      color: orange;
      cursor: pointer;
      span{
        color: red;
      }
    }
  }

  .upload_box {
    height: 282px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #eeeeee;
  }
  // 填写链接
  .upload_href {
    width: 400px;
    margin: 30px auto;
  }
}
.teach_url {
  margin: 15px 0;
}
//   视频
.vid_active {
  width: 260px;
  height: 130px;
  margin-left: 100px;
  video {
    width: 100%;
    height: 100%;
  }
}
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload_list {
  width: 640px;
  margin: 0 auto;
  padding-bottom: 50px;

  .btn_box {
    width: 100%;
    text-align: right;
    margin-top: 28px;

    ::v-deep .el-button {
      width: 112px;
      height: 36px;
      line-height: 36px;
      padding: 0;
      background: #50ddbb;
      border: none;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.upload_item {
  position: relative;
  padding: 17px 28px;
  border: 1px solid #eeeeee;
  margin-bottom: 20px;

  & > span {
    position: absolute;
    right: 15px;
    top: 13px;
    font-size: 24px;
    color: #eeeeee;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: #2e5cce;
    }
  }

  li {
    display: flex;
    padding-bottom: 5px;

    & > span {
      line-height: 40px;
      font-size: 14px;
      width: 80px;
      color: #e6a23c;
    }

    .avatar {
      width: 124px;
      height: 72px;
    }

    .avatar-uploader-icon {
      width: 124px;
      height: 72px;
      line-height: 72px;
    }
  }

  .line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 0%;
    background: #409eff;

    &.errLine {
      background: red;
    }
  }
  // 选择类型
  .type_allsd {
    width: 100%;
    padding: 15px 0;
  }
  //虚拟仿真富文本材料
  .xn_txt {
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;

  vertical-align: bottom;
}

.deptTable {
  overflow: hidden;
}
</style>
